import { useState } from 'react';
import IWizardStep from '../../../../interfaces/IWizardStep';
import WizardButton from '../../components/WizardButton';
import { WizardContent } from '../../components/WizardContent';
import WizardTextField from '../../components/WizardTextField';
import { WizardTitle } from '../../components/WizardTitle';
import { useToastrVanila } from '../../../../hooks/util/useToastrVanila';

interface CommentsProps extends IWizardStep {}

const Comments = (props: CommentsProps) => {
  const [loading, setLoading] = useState(false);
  const [comments, setComments] = useState(props.medicalCertificate.comments || '');
  const toastr = useToastrVanila();

  const handleSubmit = async () => {
    setLoading(true);
    await props
      .setStep(props.step + 1, {
        ...props.medicalCertificate,
        comments,
        isDraft: false,
      })
      .then(async () => {
        setLoading(false);
      })
      .catch(() => {
        toastr.error('Ocorreu um erro ao salvar os dados. Tente novamente mais tarde.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <WizardContent>
      <WizardTitle marginBotton={2}>Observação:</WizardTitle>
      <form>
        <WizardTextField
          label="Observação"
          sx={{ marginTop: '15px', width: '300px' }}
          value={comments}
          onChange={e => setComments(e.target.value)}
        />
        <WizardButton
          type="submit"
          isLoading={loading}
          disabled={loading}
          sx={{ marginTop: '100px' }}
          onClick={handleSubmit}
        >
          PRÓXIMO
        </WizardButton>
      </form>
    </WizardContent>
  );
};

export default Comments;
